export enum LovewallSubscriptionPlanKind {
  Free = "Free",
  Lite = "Lite",
  Standard = "Standard",
  Premium = "Premium",
}

export enum LovewallSubscriptionPlanDuration {
  LWSPDurationYearly = "yearly",
  LWSPDurationMonthly = "monthly",
  LWSPDurationWeekly = "weekly",
}

export type LovewallSubscriptionPlan = {
  _id: string;
  name: LovewallSubscriptionPlanKind;
  amount: number;
  duration: LovewallSubscriptionPlanDuration;
  maxLoveWallPosts: number;
  createdAt: Date;
  updatedAt: Date;
};

export enum LovewallSubscriptionActiveStatus {
  LWSStatusActive = "active",
  LWSStatusInactive = "inactive",
}

export type LovewallSubscription = {
  _id: string;
  lwsPlanID: string;
  accountID: string;
  transactionID: string;
  activeStatus: LovewallSubscriptionActiveStatus;
  packageBundleBookingID: string;
  pausedBySubscriptionID: string;
  pausedSubscriptionID: string;
  expiredAt: Date;
  cancelledAt: Date;
  createdAt: Date;
  updatedAt: Date;
};
